import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-967fcdc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-menu-item__label" }
const _hoisted_2 = {
  key: 1,
  class: "dashboard-menu-item__badge"
}

import { computed } from "vue";

interface Menu {
  id: number;
  linkTo: string;
  linkLabel: string;
  icon?: string;
  children?: Menu[];
  badge?: number | string;
  badgeCount?: number | string;
  count?: number | string;
  pendingCount?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardMenuItem',
  props: {
    item: {},
    showIcon: { type: Boolean, default: true },
    iconOnly: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const badgeCount = computed(() => {
  const value =
    props.item.badge ??
    props.item.badgeCount ??
    props.item.count ??
    props.item.pendingCount;
  if (value === undefined || value === null || value === "") {
    return "";
  }
  return String(value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["dashboard-menu-item", {
      'dashboard-menu-item--child': !_ctx.showIcon,
      'dashboard-menu-item--icon-only': _ctx.iconOnly,
    }])
  }, [
    (_ctx.showIcon && _ctx.item.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(['dashboard-menu-item__icon', _ctx.item.icon])
        }, null, 2))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.item.linkLabel), 1),
    (badgeCount.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(badgeCount.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})